// The GUI can be loaded as a script inside the exam page on another origin.
// Set webpack's asset root before GUI modules import their SVG/PNG resources.
if (typeof window !== 'undefined' && window.__EXAM_SCRATCH_CONFIG__?.scratchEditorUrl) {
    // eslint-disable-next-line no-undef, camelcase
    __webpack_public_path__ = window.__EXAM_SCRATCH_CONFIG__.scratchEditorUrl;
}
